import { InjectionToken } from '@angular/core';

export interface TelemetryConfig {
  /** Endpoint del BFF que recibe errores del frontend (POST /telemetry/errors). */
  errorsEndpoint: string;
  /** Nombre de la app que reporta (service.origin en los logs). */
  appName: string;
  /** Maximo de errores reportados por minuto (throttling). Default: 10. */
  maxErrorsPerMinute?: number;
}

export const TELEMETRY_CONFIG = new InjectionToken<TelemetryConfig>(
  'TELEMETRY_CONFIG'
);
